import React from 'react';
import ButtonSC from './button.styled';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowIcon } from '../../../assets/img/svg/button-arrow.svg';

const Button = ({ children, type, onClick, disabled, size, className, withIcon, htmlType }) => {
  return (
    <ButtonSC
      kind={type}
      size={size}
      onClick={disabled ? () => {} : onClick}
      disabled={disabled}
      className={className}
      type={htmlType}
    >
      {children} {withIcon ? <ArrowIcon /> : null}
    </ButtonSC>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  className: PropTypes.string,
  withIcon: PropTypes.bool,
  htmlType: PropTypes.oneOf(['button', 'reset', 'submit']),
};

Button.defaultProps = {
  type: '',
  size: '',
  onClick: () => {},
  children: '',
  className: '',
  withIcon: false,
  htmlType: 'submit',
};

export default Button;
